export function customUrlQueryMessage() {
    function getUrlParam(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    const gccuqmValue = getUrlParam('gccuqm');

    if (gccuqmValue) {
        let chatForm = $('.g-chatform:first');

        // Remove the 'gccuqm' parameter from the URL
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('gccuqm'); // Remove the parameter
        const newUrl = window.location.pathname + '?' + urlParams.toString();

        // Update the browser URL without reloading the page
        window.history.replaceState(null, '', newUrl);

        // Fill the form and trigger the submit action
        chatForm.find('.g-chatform-text-input').val(gccuqmValue);
        chatForm.find('.btn-send').trigger('click');
    }
}
